export default __webpack_public_path__ + "static/media/banner1.7392ce82.png";